export default __webpack_public_path__ + "img/logo.png?f10af1acbd2950255bcc077d6eddbd27";